import { render, staticRenderFns } from "./reports-upsell.vue?vue&type=template&id=722c6828&scoped=true&"
import script from "./reports-upsell.vue?vue&type=script&lang=js&"
export * from "./reports-upsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c6828",
  null
  
)

export default component.exports